import { DEFAULT_PORTAL_ROOT_ID } from './constants';

const getLastActivePortalRoot = () => {
  const roots = document.querySelectorAll('[id$="-portal"]');
  if (roots.length > 0) return roots[roots.length - 1];
  return null;
};

export const createPortalRoot = (id: string) => {
  const defaultRootEl = document.getElementById(DEFAULT_PORTAL_ROOT_ID);
  if (!defaultRootEl) {
    throw new Error('Default portal not found.');
  }
  const lastActivePortalRoot = getLastActivePortalRoot();
  const newPortalRoot = document.createElement('div');
  newPortalRoot.setAttribute('id', `${id}-portal`);
  document.body.insertBefore(
    newPortalRoot,
    (lastActivePortalRoot || defaultRootEl).nextSibling,
  );
  return newPortalRoot;
};
